import { SUPPORTED_FIVERR_LOCALES_KEYS } from '@fiverr-private/localization';

export const GENERAL_VIDEO_MODAL_NAME = 'general-video-modal';
export const VIDEO_TYPE = 'video/mp4';

export const IDS = {
    DEFAULT: 'default',
};

export const HOW_FIVERR_WORKS = {
    id: IDS.DEFAULT,
    name: 'How fiverr works? - general',
    titleKey: 'vertical_page_perseus.how_fiverr_works',
    sources: {
        [SUPPORTED_FIVERR_LOCALES_KEYS.EN_US]:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd_nl/v1/video-attachments/generic_asset/asset/ab0907217c9f9a2c1d2eee677beb7619-1626082923646/how_fiverr_works',
        [SUPPORTED_FIVERR_LOCALES_KEYS.DE_DE]:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/f958ef29a7a1f73f3814d1b18bb80b98-1660211133197/60%20SECS%20-%2016X9%20-%20DE',
        [SUPPORTED_FIVERR_LOCALES_KEYS.ES_ES]:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/f958ef29a7a1f73f3814d1b18bb80b98-1660211163251/60%20SECS%20-%2016X9%20-%20ES',
        [SUPPORTED_FIVERR_LOCALES_KEYS.FR_FR]:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/f958ef29a7a1f73f3814d1b18bb80b98-1660211163261/60%20SECS%20-%2016X9%20-%20FR',
        [SUPPORTED_FIVERR_LOCALES_KEYS.IT_IT]:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/f958ef29a7a1f73f3814d1b18bb80b98-1660211163251/60%20SECS%20-%2016X9%20-%20IT_fix',
        [SUPPORTED_FIVERR_LOCALES_KEYS.NL_NL]:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/f958ef29a7a1f73f3814d1b18bb80b98-1660211163254/60%20SECS%20-%2016X9%20-%20NL_new',
        [SUPPORTED_FIVERR_LOCALES_KEYS.PT_BR]:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/f958ef29a7a1f73f3814d1b18bb80b98-1660211163260/60%20SECS%20-%2016X9%20-%20PT',
    },
};

export const HOW_FIVERR_BUSINESS_WORKS = {
    id: IDS.DEFAULT,
    name: 'How Fiverr Business works? - general',
    titleKey: 'vertical_page_perseus.how_fiverr_business_works',
    sources: {
        [SUPPORTED_FIVERR_LOCALES_KEYS.EN_US]:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/9a426467eeedc010b4b2af9e3a6c2ed9-1690892131466/FiB%20Product%20Explainer_Long%20version_Eng%20subs',
        [SUPPORTED_FIVERR_LOCALES_KEYS.DE_DE]:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/9a426467eeedc010b4b2af9e3a6c2ed9-1690892131466/FiB%20Product%20Explainer_Long%20version_Eng%20subs',
        [SUPPORTED_FIVERR_LOCALES_KEYS.ES_ES]:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/9a426467eeedc010b4b2af9e3a6c2ed9-1690892131466/FiB%20Product%20Explainer_Long%20version_Eng%20subs',
        [SUPPORTED_FIVERR_LOCALES_KEYS.FR_FR]:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/9a426467eeedc010b4b2af9e3a6c2ed9-1690892131466/FiB%20Product%20Explainer_Long%20version_Eng%20subs',
        [SUPPORTED_FIVERR_LOCALES_KEYS.IT_IT]:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/9a426467eeedc010b4b2af9e3a6c2ed9-1690892131466/FiB%20Product%20Explainer_Long%20version_Eng%20subs',
        [SUPPORTED_FIVERR_LOCALES_KEYS.NL_NL]:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/9a426467eeedc010b4b2af9e3a6c2ed9-1690892131466/FiB%20Product%20Explainer_Long%20version_Eng%20subs',
        [SUPPORTED_FIVERR_LOCALES_KEYS.PT_BR]:
            'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/9a426467eeedc010b4b2af9e3a6c2ed9-1690892131466/FiB%20Product%20Explainer_Long%20version_Eng%20subs',
    },
};
